import { MdLibraryMusic } from 'react-icons/md'
import LibraryList from './LibraryList'
import LibraryEdit from './LibraryEdit'
import LibraryCreate from './LibraryCreate'

export default {
  icon: MdLibraryMusic,
  list: LibraryList,
  edit: LibraryEdit,
  create: LibraryCreate,
}
